module.exports = __webpack_public_path__ + "img/champagne-glass.1cd4fd83.svg";